var map = {
	"./apple-music.svg": 428,
	"./artist-card-overlay-green.svg": 429,
	"./cookie.svg": 256,
	"./facebook.svg": 430,
	"./instagram.svg": 431,
	"./overlayvideo.svg": 291,
	"./sponsor.svg": 257,
	"./spotify.svg": 432,
	"./tiktok.svg": 433,
	"./twitter.svg": 434,
	"./website.svg": 435,
	"./x-pattern-overlay.svg": 436,
	"./youtube.svg": 437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 427;